import { Col, Row } from 'antd';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/generalUI/Button';
import styles from './Header.module.scss';

export interface HeaderProps {
  title: string;
  subtitle: string;
  coverImage: string;
  quoteHref?: string;
  quoteExternal?: boolean;
}

const Header: FC<HeaderProps> = ({
  title,
  subtitle,
  coverImage,
  quoteHref,
  quoteExternal,
}: HeaderProps) => {
  const { t } = useTranslation();

  return (
    <Row className={styles.Container}>
      <Col className={styles.MainTextContainer} xs={24} sm={8}>
        <h3 className={styles.UpperText}>{t('pages.programs.detail.programs')}</h3>
        <h1 className={styles.Title}>{title}</h1>
        <p className={styles.Subtitle}>{subtitle}</p>
        <Button className={styles.QuoteButton}>
          <a
            href={quoteHref}
            target={quoteExternal ? '_blank' : undefined}
            rel={quoteExternal ? 'noopener noreferrer' : undefined}
          >
            {t('pages.programs.detail.quote')}
          </a>
        </Button>
      </Col>
      <Col className={styles.MainImageContainer} xs={24} sm={16}>
        <img className={styles.MainImage} src={coverImage} alt="Program cover" />
      </Col>
    </Row>
  );
};

Header.defaultProps = {
  quoteHref: '#quote-program',
  quoteExternal: false,
};

export default Header;
